import angular from 'angular';
import uiRouter from 'angular-ui-router';

import authComponent from './auth.component';
import forgotPassword from './forgot-password/forgot-password.module';
import login from './login/login.module';
import resetPassword from './reset-password/reset-password.module';
import resetPasswordFromPin from './reset-password-frompin/reset-password-frompin.module';

import './auth.scss';

export default
  angular.module('components.auth', [
    uiRouter,
    forgotPassword,
    login,
    resetPassword,
    resetPasswordFromPin
  ])
    .component('auth', authComponent)
    .config(($stateProvider, $urlRouterProvider) => {
      'ngInject';

      $stateProvider
        .state('auth', {
          url: '/auth',
          component: 'auth',
          resolve: {
            layout: () => 'column',
            flex: () => '100'
          }
        });

      $urlRouterProvider.otherwise('/auth/login');
    })
    .name;



// WEBPACK FOOTER //
// ./components/auth/auth.module.js